export default "__VITE_ASSET__A3YTdazD__";